import Button from 'components/Button/Button';
import Icon from 'components/Icon/Icon';
import Text from 'components/Text/Text';
import {changeModeAC} from 'features/beersManager/slice';
import {beerManagerModes} from 'features/beersManager/typescript';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import './AddBeersHeader.scss';

const AddBeersHeader = () => {
  const dispatch = useSetGlobalState();

  const handleGoBack = () => dispatch(changeModeAC(beerManagerModes.listBeers));

  return (
    <thead className="add-beers-header">
      <tr>
        <td className="add-beers-header__back">
          <Button variant="empty" onClick={handleGoBack}>
            <Icon icon="chevron-left" />
          </Button>
        </td>
        <td className="add-beers-header__name">
          <Text tag="span">Name</Text>
        </td>
        <td className="add-beers-header__check" />
      </tr>
    </thead>
  );
};

export default AddBeersHeader;
